import React from "react";

import Button from "@common/components/Button/Button";
import Heading from "@common/components/Heading/Heading";
import Paragraph from "@common/components/Paragraph/Paragraph";
import { Spinner } from "@common/components/Spinner/Spinner";
import { PlatformName } from "@common/models";
import { useAppSelectionContext } from "@main/context/App/AppSelectionContext";
import useAppHangFreeSessionsScoring from "@main/pages/Release/consumers/useAppHangFreeSessionsScoring";
import { MetricScoreOutletContext } from "@main/pages/Release/views/MetricDetails/ReleaseMetricDetailsLayout";
import { MetricRow } from "@main/pages/Release/views/MetricDetails/shared/MetricRow";
import * as Styled from "main/pages/Release/views/MetricDetails/AppHangFreeSessions/AppHangFreeSessionsScoreView.styles";
import * as MetricDetailsStyled from "main/pages/Release/views/MetricDetails/MetricDetails.styles";
import { useOutletContext } from "react-router-dom";

export default function AppHangFreeSessionsScoreView() {
  const { refetchReleaseStatus } = useOutletContext<MetricScoreOutletContext>();
  const { thresholdRows, scoringConfigLoading, handleSave, isSaving } =
    useAppHangFreeSessionsScoring(refetchReleaseStatus);
  const hasThresholdError = thresholdRows.some((t) => Boolean(t.error));

  const { selectedApp } = useAppSelectionContext();

  if (scoringConfigLoading) {
    return <Spinner />;
  }

  return (
    <div style={{ padding: "3.2rem 0" }}>
      <MetricDetailsStyled.MetricsCard>
        <Heading
          heading3
          marginBottom={24}
        >
          Score
        </Heading>

        <Paragraph>
          {`Feel free to fine-tune how the '${
            selectedApp?.platform.name === PlatformName.ANDROID ? "ANR-free sessions" : "App hang-free sessions"
          }' score is calculated.\n` +
            "Within each range, the score interpolates linearly between adjacent thresholds. A value exactly halfway between two thresholds gives a score halfway between their assigned scores."}
        </Paragraph>

        <Styled.ThresholdList>
          {thresholdRows.map((row) => (
            <MetricRow
              key={row.score}
              description={row.description}
              value={row.value}
              error={row.error}
              onChange={row.onChange}
              score={row.score}
              unit={"%"}
              showScore
            />
          ))}
        </Styled.ThresholdList>

        <Button
          type="submit"
          size="small"
          disabled={hasThresholdError || isSaving}
          onClick={handleSave}
        >
          {isSaving ? "Saving..." : "Save"}
        </Button>
      </MetricDetailsStyled.MetricsCard>
    </div>
  );
}
